import React, { useRef } from 'react';
import { useClickAway } from 'react-use';
import cn from 'classnames';
import moment from 'moment';

import DropdownFoldout from 'components/generic/DropdownFoldout.component';
import useTip from 'hooks/useTip.hook';
import { useTheme } from 'providers/Theme.provider';

import CN from './TimePicker.module.scss';

const formatTime = (value) => moment(value, 'hh:mm a').format('hh:mm a');

const calculateAvailableTimes = (options) => {
  const minTime = options?.minTime || '07:00 am';
  const maxTime = options?.maxTime || '10:00 pm';
  const times = [];
  const time = moment(minTime, 'hh:mm a');

  if (options?.minTime) {
    time.add(30, 'minutes');
  }

  const minimumClosingTime = moment(maxTime, 'hh:mm a');

  while (time.isBefore(minimumClosingTime) || time.isSame(minimumClosingTime)) {
    times.push(time.format('hh:mm a'));
    time.add(15, 'minutes');
  }

  return times;
};

const TimePicker = ({ selectedTime, onTimeSelect, name, position, minTime }) => {
  const { isDarkMode } = useTheme();

  const { val: isOpen, nay: close, tip: toggle } = useTip(false);

  const dropdownRef = useRef(null);
  useClickAway(dropdownRef, close);

  const adjustedMinTime = minTime;

  const availableTimes = calculateAvailableTimes({ minTime: adjustedMinTime });

  return (
    <div
      data-bem="TimePicker"
      ref={dropdownRef}
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.label}>{name}</div>
      <div className={CN.relative}>
        <div data-bem="TimePicker__button" className={CN.timeButton} onClick={toggle}>
          {formatTime(selectedTime)}
        </div>

        {isOpen && (
          <DropdownFoldout width="max" position={position}>
            <DropdownFoldout.Body>
              <div className={CN.dropdownContent}>
                {availableTimes.map((hour) => {
                  const isSelected = moment(hour, 'hh:mm a').isSame(moment(selectedTime, 'HH:mm:ss'));
                  return (
                    <div
                      key={hour}
                      className={cn({
                        [CN.dropdownItem]: true,
                        [CN.selected]: isSelected,
                      })}
                      onClick={() => {
                        onTimeSelect(hour);
                        close();
                      }}
                      role="button"
                    >
                      {hour}
                    </div>
                  );
                })}
              </div>
            </DropdownFoldout.Body>
          </DropdownFoldout>
        )}
      </div>
    </div>
  );
};

export default TimePicker;
